import { render, staticRenderFns } from "./InputSocialSecurity.vue?vue&type=template&id=531f96f1"
import script from "./InputSocialSecurity.vue?vue&type=script&lang=js"
export * from "./InputSocialSecurity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports